/*
 * @Author: Merlin
 * @Date: 2024-02-19 15:27:15
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-02 11:51:43
 * @Description: 
 */
import step01 from '../img/rules/multiple.webp';
import step01_m from '../img/rules/multiple_mobile.png';
// =========================================================
import lineImg from '../img/rules/lines.webp';
import lineImg_m from '../img/rules/lines_mobile.webp';



export const aPharaohRule01 = [{
    content1: 'pharaoh.ruleDesc01',
    constent2: '',
    img: step01,
    imgMobile: step01_m,
}];


export const aPharaohRule02 = [{
    content1: '',
    constent2: '',
    img: lineImg,
    imgMobile: lineImg_m,
}];


